import { useLocation, useNavigate } from "react-router-dom";
import "../css/navigation.css";

function BottomNavigation() {
    const navigate = useNavigate();
    const location = useLocation();
    const menus = [
        { title: "홈", icon: "⌂", path: "/dashboard" },
        { title: "종목", icon: "⌕", path: "/stock" },
        { title: "자동", icon: "▶", path: "/auto" },
        { title: "리포트", icon: "◫", path: "/log" },
        { title: "설정", icon: "⚙", path: "/setting" }
    ];

    return (
        <nav className="bottom-nav" aria-label="주요 메뉴">
            {menus.map((menu) => {
                const active = location.pathname === menu.path;
                return (
                    <button
                        type="button"
                        key={menu.path}
                        className={active ? "bottom-item active" : "bottom-item"}
                        aria-current={active ? "page" : undefined}
                        onClick={() => navigate(menu.path)}
                    >
                        <span className="bottom-icon">{menu.icon}</span>
                        <span className="bottom-text">{menu.title}</span>
                    </button>
                );
            })}
        </nav>
    );
}

export default BottomNavigation;
